<mat-toolbar color="primary" class="widget-toolbar">
    <span>Traitements</span>
    <button (click)="newTreatment()" mat-icon-button class="example-icon favorite-icon" aria-label="Example icon-button with heart icon">
        <mat-icon>note_add</mat-icon>
    </button>
    <span class="toolbar-spacer"></span>
    <!-- <button mat-icon-button class="example-icon favorite-icon" aria-label="Example icon-button with heart icon">
        <mat-icon>search</mat-icon>
    </button>     -->
</mat-toolbar>
<div class="widget-table-container">
    <app-medication-list [location]="'dashboard'" class="widget-content"></app-medication-list>
</div>